/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import NoteAdd from '@material-ui/icons/NoteAdd';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button, List, ListItem, ListItemText, Paper, makeStyles } from '@material-ui/core';
import moment from 'logic/moment';
import CircularProgress from 'components/shared/CircularProgress';
import StatusText from 'components/shared/StatusText';

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  button: {
    margin: theme.spacing(2),
  },
  center: {
    justifyContent: 'center',
    display: 'flex',
  },
}));

const formatDate = (dateStr) => moment(dateStr).format('LLLL');

const OffersTab = ({ bookings, conversationId, isHost, showLoader }) => {
  const classes = styles();

  return (
    <div className={classes.root}>
      <Paper>
        {showLoader && <CircularProgress />}

        {!showLoader && (
          <List disablePadding>
            <ListItem divider>
              <ListItemText
                primary={
                  <FormattedMessage
                    id="offersTab.bookingTabText"
                    defaultMessage="Here you can send and receive booking offers in Stugknutens booking
                      service, {clickHere} to learn more about how it works."
                    values={{
                      clickHere: (
                        <a role="button" tabIndex={0} onClick={window.supportHeroWidget.show}>
                          <FormattedMessage id="click here" defaultMessage="click here" />
                        </a>
                      ),
                    }}
                  />
                }
              />
            </ListItem>
            {bookings.map(({ id, check_in, check_out, cottage, status }) => (
              <ListItem
                key={id}
                divider
                component={Link}
                to={`/conversations/${conversationId}/bookings/${id}`}
              >
                <ListItemText
                  primary={`#${id} ${cottage.title_sv}`}
                  secondary={`${formatDate(check_in)} → ${formatDate(check_out)}`}
                />
                <div>
                  <StatusText status={status} />
                </div>
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
      {isHost && (
        <div className={classes.center}>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to={`/conversations/${conversationId}/bookings/new`}
            className={classes.button}
          >
            <NoteAdd />
            <FormattedMessage
              id="offersTab.createNewOffer"
              defaultMessage="Create a booking offer"
            />
          </Button>
        </div>
      )}
    </div>
  );
};

OffersTab.propTypes = {
  bookings: PropTypes.arrayOf(PropTypes.shape({})),
  conversationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isHost: PropTypes.bool.isRequired,
  showLoader: PropTypes.bool,
};

export default OffersTab;
